import SuccessPage from '../RegulatoryValidation/SuccessPage'
import UpdateNomineeDetails from './UpdateNomineeDetails'
import Notify from './Notify'
import { RouteComponentProps, Router } from '@gatsbyjs/reach-router'

export default function UpdateNominee(_props: RouteComponentProps) {
    return (
        <Router style={{ display: "flex", height: "100%" }}>
            <UpdateNomineeDetails path="/" default />
            <Notify path="/notify" />
            <SuccessPage path="/successPage" />
        </Router>
    )
}
